import React from 'react';

/**
 * A sophisticated, geometric 'Bouncing Square Grid' loader animation.
 * This aesthetic design uses a 3x3 grid of squares where each element 
 * scales and fades in a staggered sequence, creating a mesmerizing wave effect.
 */
const LoadingAnimation = () => {
  const animationStyles = `
    /* Container for centering the loader */
    .loader-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 150px;
      width: 100%;
      grid-column: 1 / -1; 
      padding: 20px 0;
      /* Add some subtle perspective for the grid to look good */
      perspective: 100px; 
    }
    
    /* Wrapper for the 3x3 grid */
    .grid-wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(3, 1fr);
      gap: 5px; /* Spacing between squares */
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
    }

    /* Individual Square Styling */
    .grid-square {
      width: 100%;
      height: 100%;
      background-color: #f97316; /* Orange color */
      transform: scale(0); /* Start scaled down (invisible) */
      border-radius: 4px; /* Soft edges */
      animation: grid-pulse 1.8s infinite ease-in-out;
    }
    
    /* Staggered Animation Timing (Creates the wave pattern) */
    .grid-square:nth-child(1) { animation-delay: 0.0s; } /* Top-Left */
    .grid-square:nth-child(2) { animation-delay: 0.2s; }
    .grid-square:nth-child(3) { animation-delay: 0.4s; } /* Top-Right */
    
    .grid-square:nth-child(4) { animation-delay: 0.2s; }
    .grid-square:nth-child(5) { animation-delay: 0.4s; } /* Center */
    .grid-square:nth-child(6) { animation-delay: 0.6s; }
    
    .grid-square:nth-child(7) { animation-delay: 0.4s; } /* Bottom-Left */
    .grid-square:nth-child(8) { animation-delay: 0.6s; }
    .grid-square:nth-child(9) { animation-delay: 0.8s; } /* Bottom-Right */

    /* Text Styling */
    .loading-text {
      margin-top: 16px; 
      font-size: 1.125rem; 
      color: #6b7280;
      font-family: 'Arial', sans-serif;
      animation: text-pulse 1.5s infinite ease-in-out; 
    }

    /* Animation Keyframes for the grid squares: scale and fade */
    @keyframes grid-pulse {
      0%, 100% {
        transform: scale(0);
        opacity: 0;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
      80% {
        transform: scale(0);
        opacity: 0;
      }
    }
    
    /* Animation Keyframes for text pulse (reused) */
    @keyframes text-pulse {
      0% { opacity: 0.8; }
      50% { opacity: 0.4; }
      100% { opacity: 0.8; }
    }
  `;

  return (
    <div className="loader-container">
      {/* Inject the custom CSS styles into the component */}
      <style>{animationStyles}</style>

      <div className="grid-wrapper">
        {/* A 3x3 grid of squares */}
        {[...Array(9)].map((_, index) => (
          <div key={index} className="grid-square"></div>
        ))}
      </div>
      
      <p className="loading-text">Loading Jobs...</p>
    </div>
  );
};

export default LoadingAnimation;